import React from "react";
import { Grid, Typography } from "@mui/material";
import Button from '@mui/material/Button';
import dayjs from "dayjs";
import PrintIcon from '@mui/icons-material/Print';
import Modal from "../Modal";

import { CONFIG } from "../../Config";


import logo from "../../assets/images/im-bottom-logo.png";


const ElectionLetter = ({ open, handleClose, profileData, print, printElection }) => {

    return (
        <>
            <Modal open={open} title="Election letter" handleClose={handleClose} className="dialogStyle" screenFull={true} >
                <Grid container className="padding-20" >
                    <Grid item xs={12} className="flex justifyC-end" >
                        <Button variant="contained" onClick={print} endIcon={<PrintIcon variant="btnIcon" />}>Print</Button>
                    </Grid>
                    <div className={printElection ? "printOnly" : ""}>

                        <Grid item xs={12} className="text-center" >
                            <img width="180px" height="auto" src={logo} />
                        </Grid>
                        <Grid item xs={12} className="padding-20" >
                            <div className="flex direction-column" >
                                <Typography variant="menuLabel">Date: {dayjs().format("DD-MM-YYYY")}</Typography>
                                <Typography variant="menuLabel">To,</Typography>
                                <Typography variant="menuLabel">Mr./Ms.: {profileData.account_name}</Typography>

                                <Typography variant="menuLabel">PAN: {profileData.pan}</Typography>
                                <div className="flex justifyC-center">
                                    <Typography variant="menuLabel" className="underLine">To Whomsoever It May Concern</Typography>
                                </div>
                            </div>



                            <div className="flex direction-column row-gap-10 p-rl-20">


                                <Typography variant="print">Instant Mudra Technologies Private Limited is a Business Correspondent (BC) with Yes Bank Ltd, Airtel
                                                                Payments Bank Limited, Suryodaya Small Finance Bank Limited, Zilla Sahakari Bank Gorakhpur and
                                                                offers services as per the Business Correspondent guidelines, formed for financial inclusion, by the
                                                                Reserve Bank of India (RBI).
                        </Typography>



                                <Typography variant="print" >
                                    Key services offered by a BC include Cash-deposit and Cash-withdrawal in the Bank account of the
            customers. The Company has appointed Business Correspondent Agent (BCA) / Retail Agents to
            facilitate financial inclusion services. The BCA / Retail Agents deposits cash in the bank account of the
            Company and against this deposit services to customers having bank accounts, as per the limits
            prescribed under RBI guidelines. Like an extension of a bank counter, the BCA accepts small amounts of
            deposits in cash from a customer and instructs a deposit transaction to be initiated from the Sponsor
            Bank. The money is remitted by Sponsor Bank to the bank account of the end customer after going
            through checks like limit, velocity and periodicity as permitted by the RBI.
                        </Typography>


                                <Typography variant="print">
                                    To service a customer with a deposit transaction, the BCA has to make an advance deposit of the amount
            in the bank account of BC (i.e. the Company) with Sponsor or other Banks and get a prepaid limit (similar
            to a mobile recharge transaction). The Company reduces its limits of the BCA after every deposit
            transaction. The amount received by the BCA in cash from the customer is deposited by BCA in the
            company’s bank account to replenish the limits for serving more customers.
                        </Typography>

                                <Typography variant="print">
                                    The person mentioned above is our Business Correspondent Agent “BCA” / Strategic Business Partner
            “SBP”. We request you to allow him to deposit the funds in our Company's bank account to conduct
            business as a BCA.
                        </Typography>

                                <Typography variant="print">
                                    Once the cash is deposited in our company’s bank account, we can give confirmation of the amount
            deposited in our bank account to the government authority, if required.
            This letter is issued solely to ensure continuance of Business Correspondent services. We request you to
    report to the Company at <b>compliance@instantmudra.co.in</b> if it is noticed that this letter is being used for
                                                                                                                                                                                                                                                                    any other purpose than continuance of Business Correspondent services provided by the Company.
                        </Typography>
                            </div>

                            <br />

                            <Typography variant="menuLabel" className="p-rl-20" >For Instant Mudra Technologies Pvt Ltd</Typography>
                            <br />
                            <Typography variant="menuLabel" className="p-rl-20"  >Authorized Signatory</Typography>
                            <div>
                                <img height={printElection ? "100" : "150px"} src="https://beta.instantmudra.net/apps/beta/media/images/sign4.png" />
                            </div>


                            <Typography variant="coloredh4" className="text-center"  >Instant Mudra Technologies Private Limited</Typography>

                            <Typography variant="print" className="text-center display-block">
                                Registered Office - Building F, 5th Floor, PUDHARI BHAVAN, PLOT NO. 29 TO 32 AND 36, 37, SEC-30A, NEAR
                        </Typography>
                            <Typography variant="print" className="text-center display-block"> SANPADA RAILWAY STATION, SANPADA, NAVI MUMBAI - 400705</Typography>
                            <Typography variant="print" className="text-center display-block">CIN NO. U72900MH2019PTC326135</Typography>

                        </Grid>
                    </div>

                </Grid>

            </Modal>

        </>

    )
}

export default ElectionLetter